import React from 'react';
import { usePanelStreamUrl } from '@/hooks/usePanelStreamUrl';

/**
 * Native <video> playback for panel recordings via the short-lived stream-url
 * endpoint. Used by the Panels tab and Client Report deep-dive modal.
 */
export function PanelRecordingPlayer({
  panelId,
  artifactId,
  streamUrlPath,
  className = 'w-full rounded-md bg-black',
  testId,
}) {
  const path = streamUrlPath
    || (panelId && artifactId ? `/panels/${panelId}/recordings/${artifactId}/stream-url` : null);

  const { data: src, isLoading, isError, error } = usePanelStreamUrl(path);

  if (isLoading) {
    return <p className="text-xs text-muted-foreground">Preparing playback…</p>;
  }
  if (isError) {
    const detail = error?.response?.data?.detail;
    const msg = typeof detail === 'string'
      ? detail
      : detail?.message || 'Could not load recording.';
    return <p className="text-xs text-destructive">{msg}</p>;
  }
  if (!src) return null;

  return (
    <video
      controls
      preload="metadata"
      playsInline
      className={className}
      data-testid={testId}
    >
      <source src={src} />
    </video>
  );
}
